import type React from "react";

/**
 * Add a displayName property to a component. This allows storybook to
 * display components that are wrapped in ForwardRef properly.
 */
export function withDisplayName<T>(component: T, displayName: string): T {
  (component as { displayName?: string }).displayName = displayName;
  return component;
}

/**
 * MUI 5 types some runtime forwardRef components as plain functions. Native
 * TS7 then drops refs and component-specific props from JSX inference.
 */
export function asMuiForwardRef<Props, Element>(
  component: React.ComponentType<Props>,
): React.ForwardRefExoticComponent<
  React.PropsWithoutRef<Props> & React.RefAttributes<Element>
> {
  return component as React.ForwardRefExoticComponent<
    React.PropsWithoutRef<Props> & React.RefAttributes<Element>
  >;
}
